var updatingGoJs = false

module.exports = updatingGoJs;